class StopLookupsCollection extends App.Collections.BaseCollection {
    url = 'Stop';
    model = App.Models.StopLookup;
}

App.Collections.StopLookups = StopLookupsCollection;
